module.exports = __webpack_public_path__ + "ionicPostit.svg?4f0ca6ceb604dc84305e2a038b2c0f37";